import { Injectable } from '@angular/core';
import { Headers, Http, Jsonp } from '@angular/http';

import 'rxjs/add/operator/toPromise';


@Injectable()
export class DeezerService {
  private searchUrl = 'https://api.deezer.com/search?output=jsonp&callback=JSONP_CALLBACK&q='
  constructor(private http: Http, private _jsonp: Jsonp){}

  search(value) {
    const url = this.searchUrl + value;
    return this._jsonp.get(url)
    .toPromise()
    .then(response => {
        console.log('response : ', response)
        return response.json();
    })
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/home/deezer.service.ts